const getSpeseAccessorie = function (state) {
  return [...state.spese]
}

const getSpeseAccessorieSelected = function (state) {
  let list = []
  state.spese.forEach(arr => {
    list = list.concat(arr.filter(item => item.selected))
  })
  return list
}

export default {
  getSpeseAccessorie,
  getSpeseAccessorieSelected
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/spese.js